import $http from "@/plugins/axios.js";

export default {
  state: {
    countries: null,
    number: null,
    phoneMessage: null,
  },
  getters: {
    countries: (state) => state.countries,
    number: (state) => state.number,
    phoneMessage: (state) => state.phoneMessage,
  },
  mutations: {
    SET_COUNTRIES(state, data) {
      const countriesArray = Object.values(data);
      state.countries = countriesArray;
    },
    SET_NUMBER(state, data) {
      state.number = data;
    },
    SET_PHONE_MESSAGE(state, data) {
      state.phoneMessage = data;
    },
  },
  actions: {
    async getCountries({ commit, dispatch }) {
      dispatch("toggleIsLoading", true);
      try {
        const res = await $http.get(`otp/countries`);
        dispatch("toggleIsLoading", false);
        commit("SET_COUNTRIES", res.data.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_COUNTRIES", null);
        throw err;
      }
    },
    async getNumber({ dispatch, commit }, id) {
      dispatch("toggleBtnLoading", true);
      try {
        const res = await $http.post("/otp/number", {
          id: id,
        });
        dispatch("toggleBtnLoading", false);
        commit("SET_NUMBER", res.data.data);
      } catch (err) {
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.message,
            duration: 3,
          });
        } else if (err.response.status === 429) {
          dispatch("pushAlert", {
            alertVariant: "warning",
            alertMessage: "لقد طلبت ارقام كثيرة, حاول مجدداََ في وقت لاحق",
            duration: 5,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },
    async getPhoneMessageAPI({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        const res = await $http.post("/otp/otp", payload);
        dispatch("toggleBtnLoading", false);
        commit("SET_PHONE_MESSAGE", res.data.data);
      } catch (err) {
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },
  },
};
